import { Component, OnInit, Input } from '@angular/core';
import { BaseComponent } from '../base/base.component';
import { ClassUsageLimits } from '../data/class-usage-limits';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-usage-limits',
  templateUrl: './class-usage-limits.component.html',
  styleUrls: ['./class-usage-limits.component.css']
})
export class ClassUsageLimitsComponent extends BaseComponent implements OnInit {

  @Input() classId: number;

  readonly noActivityLimitValue = 999;
  readonly noActivityLimitDescription = "No Limit";

  readonly activityCountLimits = [
    this.noActivityLimitValue, 1, 2, 3, 4, 5, 6, 7, 8, 9, null, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
  ];

  readonly unitLimits = [
    {
      name: 'No Limit',
      value: null
    },
    {
      name: 'Unit 1',
      value: 1
    },
    {
      name: 'Unit 2',
      value: 2
    },
    {
      name: 'Unit 3',
      value: 3
    },
    {
      name: 'Unit 4',
      value: 4
    },
    {
      name: 'Unit 5',
      value: 5
    },
    {
      name: 'Unit 6',
      value: 6
    },
    {
      name: 'Unit 7',
      value: 7
    },
    {
      name: 'Unit 8',
      value: 8
    },
    {
      name: 'Unit 9',
      value: 9
    },
    {
      name: 'Unit 10',
      value: 10
    },
    {
      name: 'Unit 11',
      value: 11
    },
    {
      name: 'Unit 12',
      value: 12
    },
    {
      name: 'Unit 13',
      value: 13
    },
    {
      name: 'Unit 14',
      value: 14
    },
    {
      name: 'Unit 15',
      value: 15
    },
    {
      name: 'Unit 16',
      value: 16
    },
    {
      name: 'Unit 17',
      value: 17
    },
    {
      name: 'Unit 18',
      value: 18
    },
    {
      name: 'Unit 19',
      value: 19
    },
    {
      name: 'Unit 20',
      value: 20
    },
    {
      name: 'Unit 21',
      value: 21
    },
    {
      name: 'Unit 22',
      value: 22
    },
    {
      name: 'Unit 23',
      value: 23
    },
    {
      name: 'Unit 24',
      value: 24
    }
  ];
  
  usageLimits: ClassUsageLimits;
  isSaving: boolean;

  ngOnInit() {
    this.dataService.getClassUsageLimits(this.classId).subscribe(result => {
      this.usageLimits = result;

      // Null now represents default in all cases. 10 being in the database is a mistake that will get corrected here.
      if (this.usageLimits.DailyActivityLimit === 10) {
        this.usageLimits.DailyActivityLimit = null;
      }
    });
  }

  saveChanges() {
    this.isSaving = true;
    this.dataService.setClassUsageLimits(this.usageLimits).subscribe(result => {
      this.isSaving = false;
      Swal.fire({            
        title: "Saved!",
        type: "success",
        showConfirmButton: false,
        timer: 1000
      });
    });
  }

  displayDailyActivityLimit(limit: number): string {
    if(limit == null) {
      return "10";
    }
    else if (limit === 999) {
      return "No Limit";
    }
    else {
      return limit.toString();
    }
  }
}
